// Template Generated by DataExtraction.py at 1717541024

import CESGEnglishB1 from "../../Forms/CESG/CESG_EnglishB1.png";
import CESGEnglishB1Labels from "../../Labels/CESG/CESG_EnglishB1.json";
import CESGFrenchB1 from "../../Forms/CESG/CESG_FrenchB1.png";
import CESGFrenchB1Labels from "../../Labels/CESG/CESG_FrenchB1.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab, isFemale, isMale, drawText as drawTextAtPos, isAnotherGender
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";
import { t } from "i18next";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CESGFrenchB1Labels : CESGEnglishB1Labels;
    const formImage = isFrench ? CESGFrenchB1 : CESGEnglishB1;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const format = "yyyy/MM/DD";
    const beneficiary = data.beneficiary;

    const subscriber = data.subscriber;
    const jointSubscriber = data.jointSubscriber;
    const subscriber2Include = data.common.subscriber2Include;
    const application = data.application;

    let custodialParentFirstName = application.custodialParentFirstName;
    let custodialParentLastName = application.custodialParentLastName;
    let pcgFirstName = application.custodianFirstName;
    let pcgLastName = application.custodianLastName;

    const anyBlank = custodialParentFirstName === "" || custodialParentLastName === "" || pcgFirstName === "" || pcgLastName === "";
    const isCustodialParentSameAsPrimaryCaregiver = !anyBlank && (custodialParentFirstName === pcgFirstName && custodialParentLastName === pcgLastName);

    let legalGuardianCheck = true;

    const isEitherSubscriberCustodialParent = (subscriber.custodialParent) || (subscriber2Include && jointSubscriber.custodialParent);

    if (isEitherSubscriberCustodialParent) {
        legalGuardianCheck = true;
    }

    if (isCustodialParentSameAsPrimaryCaregiver) {
        legalGuardianCheck = true;
        custodialParentFirstName = "";
        custodialParentLastName = "";
    } else {
        legalGuardianCheck = false;
    }

    // drawTextAtPos(doc, 12, t("Children's Education Funds Inc."), 51 / 3.38, 283 / 3.38, 454 / 3.38);
    drawText(t("Children's Education Funds Inc."), "respProvider")
    drawText(t("1"), "numBenes")

    // // draw # dependants
    // if (!isFrench) {
    //     drawTextAtPos(doc, 12, t("1"), 494 / 3.38, 853 / 3.38, 10 / 3.38);
    // } else {
    //     drawTextAtPos(doc, 12, t("1"), 479 / 3.38, 842 / 3.38, 10 / 3.38);
    // }

    // Drawing the form
    drawText(moment(beneficiary.birthdate).format(format), "beneficiaryBirthdateYyyyMmDd");
    fillCheckbox(isFemale(beneficiary.gender), "beneficiaryFemale");
    drawText(beneficiary.firstName, "beneficiaryFirstName");
    drawText(beneficiary.lastName, "beneficiaryLastName");
    fillCheckbox(isMale(beneficiary.gender), "beneficiaryMale");
    fillCheckbox(isAnotherGender(beneficiary.gender), "beneficiaryAnother");
    drawText(beneficiary.sin, "beneficiarySIN");
    drawText(custodialParentFirstName, "custodialParentFirstName");
    drawText(custodialParentLastName, "custodialParentLastName");
    fillCheckbox(legalGuardianCheck, "legalGuardianCheck");
    drawText(application.custodianFirstName, "primaryCaregiverFirstName");
    drawText(application.custodialParentLastName, "primaryCaregiverLastName");
    drawText(application.custodianSIN, "primaryCaregiverSIN");
    drawText(subscriber.firstName, "subscriber1FirstName");
    drawText(subscriber.lastName, "subscriber1LastName");
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? CESGFrenchB1Labels : CESGEnglishB1Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];


    return signers;
}

export default {
    generate,
    signatureDefinitions
}
